<template>
  <el-popover
    v-model="visible"
    trigger="click"
    placement="bottom-start"
    :width="340"
    @after-leave="beforeClose"
  >
    <template #reference><slot /></template>
    <el-row type="flex" align="middle">
      <el-col>
        <el-radio-group v-model="org_performer_id" class="df fd-column">
          <el-radio
            v-for="org in list"
            :key="org.id"
            :label="org.id"
            class="mb-10"
          >
            {{ org.short_name }}
          </el-radio>
        </el-radio-group>
      </el-col>
      <el-col class="ta-r">
        <el-button
          :loading="loading"
          :disabled="!org_performer_id"
          type="primary"
          @click="handleSave"
        >
          Сохранить
        </el-button>
      </el-col>
    </el-row>
  </el-popover>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters } from 'vuex'

const Bids = RepositoryFactory.get('bids')

export default {
  name: 'ChoosePerformer',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    updateId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      org_performer_id: 0,
    }
  },
  computed: {
    ...mapGetters({ list: 'organizations/getOrganizations' }),
  },
  methods: {
    handleSave() {
      this.loading = true
      const data = { org_performer_id: this.org_performer_id }

      Bids.patchBids(this.id, data)
        .then(res => {
          if (res.status === 200) {
            this.visible = false
            this.$message.success('Заявка обновлена успешно')
            this.$emit('update', { id: this.updateId, data })
          }
        })
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    beforeClose() {
      this.org_performer_id = 0
    },
  },
}
</script>

<style lang="sass">
.choose-performer-modal
  .el-dialog__header
    padding: 20px 40px
    color: #000
  .el-dialog__body
    padding: 0 40px 40px
    color: #000
  .selected-row
    color: #409EFF
</style>
